import { Logger } from '@/utils/Logger';
import useChatbotStore from '../store/useChatbotStore';
import { isSessionError } from './useChatbotSession';
import { isStreamError } from './useChatbotStream';

type TranslateFn = (key: string) => string;

function isAbortError(error: unknown): error is Error {
  return error instanceof Error && error.name === 'AbortError';
}

function getChatbotErrorMessage(error: unknown, t: TranslateFn): string {
  let errorMessage = t('components.aiChatDrawer.chatMessage.genericError');

  if (isSessionError(error) || isStreamError(error)) {
    if (error.status >= 500) {
      errorMessage = t('components.aiChatDrawer.chatMessage.serverError');
    }
  }

  return errorMessage;
}

export function handleChatbotFailure(error: unknown, t: TranslateFn): void {
  if (isAbortError(error)) return;

  if (isSessionError(error) || isStreamError(error)) {
    Logger.warn('useChatbot', `Chatbot request failed (status ${error.status}): ${error.message}`);
  }

  const store = useChatbotStore.getState();
  store.setError({ message: getChatbotErrorMessage(error, t), retryable: true });
  store.finalizeAiMessage();
}
